<template>
  <h1>InputBarPillDev</h1>

  <div class="row">
    <input-bar-pill v-model="current" :choices="choices" />
  </div>

  <div class="row">
    <p><strong>Current value:</strong> {{ current ? current : '(none)' }}</p>
    <p><strong>Has value:</strong> {{ hasValue ? 'True' : 'False' }}</p>
    <button class="btn btn-success" @click="randomizeValue">
      Randomize value
    </button>
  </div>
</template>

<script>
import InputBarPill from './InputBarPill.vue';
import DevComponentContainer from '../../DevComponent/DevComponentContainer';
import { pickRandom } from '@/utils/arrayUtil';

export default {
  name: 'InputBarPillDev',
  components: { InputBarPill },
  extends: DevComponentContainer,
  data() {
    return {
      current: null,
      choices: [
        { value: '1', label: '0' },
        { value: '2', label: '1' },
        { value: '3', label: '2' },
        { value: '4', label: '3' },
        { value: '5', label: '3+' },
      ],
    };
  },
  computed: {
    hasValue() {
      return this.current !== null;
    },
  },
  methods: {
    randomizeValue() {
      this.current = pickRandom(this.choices).value;
    },
  },
};
</script>
